import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable, catchError, of, switchMap, throwError } from 'rxjs';

import { environment } from '@/environments/environment';

import { AuthService } from '@authcore/auth.service';
import { AuthUtils } from '@authcore/auth.utils';
import { UserService } from '@authuser/user.service';
import { IdentityTokenType } from '@authuser/user.types';

export const AuthGuard: CanActivateFn | CanActivateChildFn  = (): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> =>
{
    const authService = inject(AuthService);
    const router: Router = inject(Router);
    const userService = inject(UserService);

    switch (true) {
        case (authService.token && !authService.instanceCode):

            return of(router.parseUrl('sign-in/instances'));

        case (!authService.token || !authService.instanceCode):

            return of(router.parseUrl('launch'));

        case AuthUtils.isTokenExpired(authService.token):

            const queryParams = {
                client_id: environment.client_id,
                grant_type: 'refresh_token',
                refresh_token: authService.refreshToken
            };

            return AuthUtils.getIdentityToken(queryParams).pipe(
                switchMap(({ access_token, refresh_token }: IdentityTokenType) => {
                    AuthUtils.token = access_token;
                    AuthUtils.refreshToken = refresh_token;

                    //access_token assume isAuthenticated
                    if (access_token) {
                        return of(true);
                    }

                    return of(router.parseUrl('launch'));
                }),
                catchError((e) => {
                    console.error(e);

                    AuthUtils.token = '';
                    AuthUtils.idtoken = '';
                    AuthUtils.refreshToken = '';

                    return of(router.parseUrl('launch'));

                    ////Common.showSnackBarMessageError(e);

                    //if (!e) {
                    //    return of(router.parseUrl('launch'));
                    //}

                    //if (e.status == '400') {
                    //    window.location.href = `${environment.base_uri}/sign-out`;

                    //    return throwError(() => e);
                    //}

                    //if (e.status == '403' || e.status === '401') {

                    //    //var message = '';
                    //    //if (e.error && e.error.length > 0) {
                    //    //    message = e.error[0].phrase;
                    //    //} else {
                    //    //    message = e.message;
                    //    //}

                    //    return throwError(() => e);
                    //}

                    //return throwError(() => e);
                })
            );

        case !AuthUtils.isTokenExpired(authService.token):
            
            return authService.validate().pipe(
                switchMap((user: any) => {
                    if (user) {
                        userService.refreshCache();
                    }

                    if (user)
                        return of(true);
                    else
                        return of(router.parseUrl('forbidden'));
                })
            );

        default:

            return of(router.parseUrl('launch'));
    }
};
